import {useState} from "react";

enum FILTER_PANEL {
  ORGANIZATION_TYPE= 'organizationType',
  REGION = 'region',
  ONLINE_RESERVATION = 'onlineReservation',
}
const DEFAULT_SELECTED = ['不限'];

export const useMedicalOrganizationFilter = () => {
  const [openPanel, setOpenPanel] = useState<FILTER_PANEL | ''>('');
  const [selectedOrganizationType, setSelectedOrganizationType] = useState<string[]>(DEFAULT_SELECTED);
  const [selectedRegions, setSelectedRegions] = useState<string[]>(DEFAULT_SELECTED);
  const [selectedOnlineReservation, setSelectedOnlineReservation] = useState<string[]>(DEFAULT_SELECTED);

  const isShowOrganizationTypeSelect = openPanel === FILTER_PANEL.ORGANIZATION_TYPE;
  const isShowRegionSelect = openPanel === FILTER_PANEL.REGION;
  const isShowOnlineReservationSelect = openPanel === FILTER_PANEL.ONLINE_RESERVATION;

  const toggleOrganizationTypePanel = () => {
    setOpenPanel(prev => (prev === FILTER_PANEL.ORGANIZATION_TYPE ? '' : FILTER_PANEL.ORGANIZATION_TYPE))
  }

  const toggleRegionPanel = () => {
    setOpenPanel(prev => prev === FILTER_PANEL.REGION ? '' : FILTER_PANEL.REGION)
  }

  const toggleOnlineReservationPanel = () => {
    setOpenPanel(prev => prev === FILTER_PANEL.ONLINE_RESERVATION ? '' : FILTER_PANEL.ONLINE_RESERVATION)
  }

  const closeAllPanels = () => setOpenPanel('');

  const onOrganizationTypeSelectionCompleted = closeAllPanels;
  const onRegionSelectionCompleted = closeAllPanels;
  const onOnlineReservationSelectionCompleted = closeAllPanels;

  const isOverlayVisible = openPanel !== '';

  return {
    selectedOrganizationType,
    selectedRegions,
    selectedOnlineReservation,
    setSelectedOrganizationType,
    setSelectedRegions,
    setSelectedOnlineReservation,
    isShowOrganizationTypeSelect,
    isShowRegionSelect,
    isShowOnlineReservationSelect,
    toggleOrganizationTypePanel,
    toggleRegionPanel,
    toggleOnlineReservationPanel,
    closeAllPanels,
    onOrganizationTypeSelectionCompleted,
    onRegionSelectionCompleted,
    onOnlineReservationSelectionCompleted,
    isOverlayVisible,
  }
}